<div class="row">
  <div class="col-md-4" [ngClass]="{'details-loading': aggrDetailLoading, 'loading': showSpinner }">
    <div class="row" *ngIf="newAggregationsVisible">
      <div [ngClass]="{'hide-checkboxes': curSelectionType ===  SelectionType.single}" class="col-md-12">
        <div class="search-box pb-3">
            <label for="client-search-box">Client Search:</label>
            <ng-select #mySelect
              id="mySelect"
              name="mySelect"
              [disabled]="showSpinner ? '' : null"
              [virtualScroll]="true"
              [items]="sharedDataService.clientParties"
              bindLabel="partyName"
              [searchFn]="matchClientPartyRow"
              (change)="onSelectedClientChange()"
              [(ngModel)]="selectedClient">
              <ng-template #mySelectOptionContent ng-option-tmp let-item="item">
                  {{item.clientParty.mailStop}} -- {{item.partyName}}
              </ng-template>
            </ng-select>
        </div>
        <div class="clearfix">
          <div class="float-left">
            <div class="btn-group btn-group-toggle" data-toggle="buttons">
              <label class="btn btn-secondary active" (click)="tab_NewOrOthers = 'new'; curSelectionType=SelectionType.single;">
                <input type="radio" name="options" id="option1" autocomplete="off" checked>
                New
              </label>
              <label class="btn btn-secondary" (click)="tab_NewOrOthers = 'other'; curSelectionType=SelectionType.single;">
                <input type="radio" name="options" id="option2" autocomplete="off">
                All Others
              </label>
              <label class="btn btn-secondary" (click)="tab_NewOrOthers = 'incompleteExtractions'; curSelectionType=SelectionType.single;">
                <input type="radio" name="options" id="option3" autocomplete="off">
                Incomplete Extractions
              </label>
            </div>
          </div>
        </div>

        <div [ngClass]="{'new': tab_NewOrOthers=='new', 'other': tab_NewOrOthers=='other', 'incompleteExtractions': tab_NewOrOthers=='incompleteExtractions' }" class="tables">
          <ngx-datatable
          id="newAndOthersAggregationsGrid"
          name="New And All Others"
          class="material striped new"
          style="height: calc(100vh - 332px);"
          [columns]="columns"
          [columnMode]="'force'"
          [headerHeight]="50"
          [footerHeight]="40"
          [rowHeight]="rowHeight"
          [count]="newRows ? newRows.length : 0"
          [rows]="newRows"
          [loadingIndicator]="showSpinner"
          [scrollbarV]="true"
          [selectionType]="curSelectionType"
          [selected]="selectedNew"
          (select)="HandleSelect($event)"
          [virtualization]="true"
          >
            <ngx-datatable-footer *ngIf="true">
              <ng-template
                ngx-datatable-footer-template
                let-rowCount="rowCount"
                let-pageSize="pageSize"
                let-selectedCount="selectedCount"
                let-curPage="curPage"
                let-offset="offset"
              >
                <div class="custom-footer">
                  <div class="page-count">
                    <span> {{selectedCount}} selected / </span> {{rowCount}} total
                  </div>
                  <div *ngIf="hasPermissionToEdit" class="table-footer-buttons">
                    <button (click)="deleteSelectedAggregations()" *ngIf="curSelectionType !==  SelectionType.single" class="btn btn-danger btn-sm">
                      Deprecate
                    </button>
                    <button (click)="changeSelectionType()" class="btn btn-outline-primary btn-sm" [ngClass]="{'active': curSelectionType !=  SelectionType.single }">
                      <i class="fa fa-pencil" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-footer>
          </ngx-datatable>

          <ngx-datatable
          id="newAndOthersAggregationsGrid"
          name="New And All Others"
          class="material striped other"
          style="height: calc(100vh - 332px);"
          [columns]="columns"
          [columnMode]="'force'"
          [headerHeight]="50"
          [footerHeight]="40"
          [rowHeight]="rowHeight"
          [count]="otherRows ? otherRows.length : 0"
          [rows]="otherRows"
          [loadingIndicator]="showSpinner"
          [scrollbarV]="true"
          [selectionType]="curSelectionType"
          [selected]="selectedOther"
          (select)="HandleSelect($event)"
          [virtualization]="true"
          >
            <ngx-datatable-footer *ngIf="true">
              <ng-template
                ngx-datatable-footer-template
                let-rowCount="rowCount"
                let-pageSize="pageSize"
                let-selectedCount="selectedCount"
                let-curPage="curPage"
                let-offset="offset"
              >
                <div class="custom-footer">
                  <div class="page-count">
                    <span> {{selectedCount}} selected / </span> {{rowCount}} total
                  </div>
                  <div class="table-footer-buttons">
                    <button (click)="deleteSelectedAggregations()" *ngIf="curSelectionType !==  SelectionType.single" class="btn btn-danger btn-sm">
                      Deprecate
                    </button>
                    <button (click)="changeSelectionType()" class="btn btn-outline-primary btn-sm" [ngClass]="{'active': curSelectionType !=  SelectionType.single }">
                      <i class="fa fa-pencil" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>

              </ng-template>
            </ngx-datatable-footer>
          </ngx-datatable>

          <ngx-datatable
            id="newAndOthersAggregationsGrid"
            name="New And All Others"
            class="material striped incompleteExtractions"
            style="height: calc(100vh - 332px);"
            [columns]="columns"
            [columnMode]="'force'"
            [headerHeight]="50"
            [footerHeight]="40"
            [rowHeight]="rowHeight"
            [count]="incompleteExtractRows ? incompleteExtractRows.length : 0"
            [rows]="incompleteExtractRows"
            [loadingIndicator]="showSpinner"
            [scrollbarV]="true"
            [selected] = ""
            [selectionType]="curSelectionType"
            [virtualization]="true"
            >
              <ngx-datatable-footer *ngIf="true">
                <ng-template
                  ngx-datatable-footer-template
                  let-rowCount="rowCount"
                  let-pageSize="pageSize"
                  let-selectedCount="selectedCount"
                  let-curPage="curPage"
                  let-offset="offset"
                >
                  <div class="custom-footer">
                    <div class="page-count">
                      <span> {{selectedCount}} selected / </span> {{rowCount}} total
                    </div>
                  </div>

                </ng-template>
              </ngx-datatable-footer>
            </ngx-datatable>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-8 details" [ngClass]="{'enabled': hasTouchedGrid && !showSpinner }" >
    <e2cb-aggregation-detail
      (onDataChange)="onDetailDataChange()"
      (loadingChange)="onDetailloadingChange($event)"
      (updateCurrentAggregation)="UpdateAggregateResult($event)"
      (OnRelatedClientChange)="onRelatedClientChange($event)"
      [hasPermissionToEdit]="hasPermissionToEdit"
    ></e2cb-aggregation-detail>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">Deprecate Listed Aggregations?</h5>
    <button style="outline: none;" type="button" class="close" aria-label="Close" (click)="modal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="table-container" style="max-height: 60vh; overflow: scroll; overflow-x: hidden;">
      <table class="table table-striped">
        <thead>
          <th>
            Client ID
          </th>
          <th>
            Exception Count
          </th>
          <th>
            Aggregation Count
          </th>
          <th>
            State
          </th>
          <th>

          </th>
        </thead>
        <tbody>
          <ng-container *ngFor="let aggregation of selectedNew">
            <tr>
              <td>{{aggregation.clientId}}</td><td>{{aggregation.exceptionCount}}</td>
              <td>{{aggregation.aggregationCount}}</td><td>{{aggregation.status}}</td>
              <td><button (click)="deselecteAggregation(aggregation)" class="btn btn-sm btn-primary">Undo</button></td>
            </tr>
          </ng-container>
          <ng-container *ngFor="let aggregation of selectedOther">
            <tr>
              <td>{{aggregation.clientId}}</td><td>{{aggregation.exceptionCount}}</td>
              <td>{{aggregation.aggregationCount}}</td><td>{{aggregation.status}}</td>
              <td><button (click)="deselecteAggregation(aggregation)" class="btn btn-sm btn-primary">Undo</button></td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modal.close(true)">Deprecate</button>
    <button type="button" class="btn btn-primary" (click)="modal.close(false)">Cancel</button>

  </div>
</ng-template>

<error-handler></error-handler>
